import { IVideoCategoriesState } from './videoCategoriesContext';
import { VideoCategoriesActionTypes, TVideoCategoriesAction } from './videoCategoriesActions';

export const videoCategoriesReducer = (
	state: IVideoCategoriesState,
	action: TVideoCategoriesAction,
): IVideoCategoriesState => {
	switch (action.type) {
		case VideoCategoriesActionTypes.SET_VIDEO_CATEGORIES:
			return {
				...state,
				videoCategories: action.payload.videoCategories,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoCategoriesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case VideoCategoriesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				currentPage: 1,
			};
		case VideoCategoriesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case VideoCategoriesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case VideoCategoriesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case VideoCategoriesActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoCategoriesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoCategoriesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
